import './barloading.css';
const Logo = `${process.env.PUBLIC_URL || ''}/assets/images/dealspotngicon.png`;

function BarLoading() {
  return (
    <div className="bar-loading">
      <div className="bar-loading-inner">
        <div className="bar-loading-logo-wrap">
          <img src={Logo} alt="DealSpotNG" className="bar-loading-logo" />
          <div className="bar-loading-text">
            <span className="text-teal">Deal</span>
            <span className="text-orange">Spot</span>
            <span className="text-teal">NG</span>
          </div>
        </div>
        <div className="bar-loading-shimmer" />
      </div>
    </div>
  );
}

export default BarLoading;
